module.exports = __webpack_public_path__ + "img/waves-5.02a4b0c9.jpg";